import { prop } from '@ipfabric/utils/fp/prop';

export const haveColumnsUniqueKeys = (columns: { key: string }[]): boolean =>
  new Set(columns.map(prop('key'))).size === columns.length;
